export default __webpack_public_path__ + "static/media/2_icon6A.e1cbec60.png";